// Opens the Joy loyalty panel from the MageCoins box on the product page.
//
// The app is third party and boots a few seconds after the page, so the box can
// be clicked before anything exists to open. Two states to handle:
//   - not booted yet: the app renders a plain launcher button inside
//     #Avada-Joy_FloatingButton, and clicking it boots and opens the panel.
//   - booted: the launcher is replaced by <joy-loyalty-widget>, which exposes
//     open() and close() methods.
// A click before either exists waits for whichever turns up first.

const FLOATING_BUTTON = '#Avada-Joy_FloatingButton';
const WIDGET = 'joy-loyalty-widget';
const TRIGGER = '[data-magecoins-trigger]';

// Long enough to cover a slow third-party boot without leaving the box stuck in
// its busy state when the app is blocked outright.
const BOOT_TIMEOUT = 10000;

let pendingTrigger = null;

function openLoyaltyWidget() {
  const widget = document.querySelector(WIDGET);
  if (typeof widget?.open === 'function') {
    widget.open();
    return true;
  }

  const launcher = document.querySelector(`${FLOATING_BUTTON} button`);
  if (launcher) {
    launcher.click();
    return true;
  }

  return false;
}

function setBusy(trigger, isBusy) {
  trigger.classList.toggle('product__magecoins--busy', isBusy);
  if (isBusy) {
    trigger.setAttribute('aria-busy', 'true');
  } else {
    trigger.removeAttribute('aria-busy');
  }
}

function openWhenReady(trigger) {
  // A second click while waiting would stack observers, so the busy trigger
  // stands in as the lock. It is re-read on each attempt because product-info.js
  // replaces the box wholesale when the variant changes.
  if (pendingTrigger) return;

  pendingTrigger = trigger;
  setBusy(trigger, true);

  const settle = () => {
    observer.disconnect();
    clearTimeout(timer);
    setBusy(trigger, false);
    pendingTrigger = null;
  };

  const observer = new MutationObserver(() => {
    if (openLoyaltyWidget()) settle();
  });

  const timer = setTimeout(settle, BOOT_TIMEOUT);

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('click', (event) => {
  // Delegated from the document: the box is re-rendered on variant change, so a
  // listener bound to the element itself would not survive.
  const trigger = event.target.closest(TRIGGER);
  if (!trigger) return;

  if (!openLoyaltyWidget()) openWhenReady(trigger);
});
